import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ProviderCommonApi from '../../../../API/provider/common-api';
import UserApi from '../../../../API/user/user-api';
import { NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../components/Basic/Buttons';
import { Input, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../../components/Basic/Table';
import { Text } from '../../../../components/Basic/WrapsStyle';
import ProviderProductsContextMenu from '../../../../components/Providers/Elements/ProductsContextMenu';
import { STATUSES_MAP } from '../../../../components/Providers/WrapsStyle/ProductContentStatus';
import { MARKETS_FILTER_DEFAULT, MARKETS_MAP, TYPE_BUTTONS } from '../../../../constans';
import { getProviderIdAndArtnumberBySku } from '../../../../utils';
import { showWarningNotify } from '../../../../utils/Notiffication';
import AvitoContentButton from '../addToMarketButtons/AvitoContentButton';
import BWhiteContentButton from '../addToMarketButtons/BwhiteContentButton';
import MegamarketContentButton from '../addToMarketButtons/MegamarketContentButton';
import OzonContentButton from '../addToMarketButtons/OzonContentButton';
import WbContentButton from '../addToMarketButtons/WbContentButton';
import YandexContentButton from '../addToMarketButtons/YandexContentButton';
import AvitoCategorySelect from '../AvitoCategorySelect';
import OzonCategorySelect from '../OzonCategorySelect';
import ProductCategorySelect from '../ProductCategorySelect';
import ContentWorkLine from './Line';
import styles from './styles.module.scss';
const width = [
  '80px', //0
  '120px', //1
  '400px', //2
  '100px', //3
  '120px', //4
  '160px', //5
  '150px', //6
  '180px', //7
  '400px', //8
  '250px', //9
  '60px', //10
  '130px', //10
  '180px', //12
  '200px', //13
  '300px', //14
];

const FILTER = {
  0: 'hasdata_content',
  1: 'loaded',
  2: 'not_loaded',
  3: 'stopbrand',
  4: 'archive',
};
const FILTER_OZON = {
  0: 'hasdata_content',
  1: 'loaded',
  2: 'not_loaded_mp',
  3: 'not_loaded',
  4: 'stopbrand',
  5: 'archive',
};

const FRONT_VALIDATION = {
  '': 'Не выбрана',
  bad_size: 'Размеры',
  bad_size_borders: 'Границы размеров',
  bad_weight: 'Вес',
  bad_weight_borders: 'Границы веса',
  bad_unit: 'Еденица измерения',
  bad_brand: 'Бренд',
  bad_category: 'Категория',
  bad_label: 'Заголовок фотошопа',
  bad_ozon_name: 'Ozon наименование',
  bad_wb_name: 'Wb наименование',
  bad_wb_category: 'Wb категория',
};

const OZON_ERROR_VALIDATION = {
  '': 'Не выбрана',
  props: 'Характеристики Озон',
  name: 'Наименование',
  no_dimensions: 'Не переданы размеры',
  bad_dimensions: 'Некорректные размеры',
  bad_category: 'Неверная категория',
  images: '*Фото',
  assorty_error: '*Ассортимент нельзя',
  bad_merge: '*Ошибка объединения',
  double: '*Дубль карточки',
  other: '*Другое',
};

const DELETE_LIST = [
  { text: 'Не выбрано', value: undefined },
  { text: 'Да', value: true },
  { text: 'Нет', value: false },
];

export const checkContentManager = (manager) => {
  if (manager.name === 'Не выбран') {
    return '';
  }
  if (manager.name === 'Не назначен') {
    return 'Не назначен';
  }

  return manager.name;
};
const CARDS_STATUS = ['', true, false];
const MODES = ['Режим контента', 'Режим габаритов', 'Режим вб', 'Режим озона', 'Режим авито', 'Режим b-white'];

function ContentWorkTable({ providerId, market, shop, setContentManager = () => { } }) {
  const [search, setSearch] = useState('');
  const [images, setImages] = useState([]);
  const [show, setShow] = useState(50);

  const [status, changeStatus] = useState('');

  const [contentMode, changeMode] = useState(MODES[0]);
  const [isDelete, setIsDelete] = useState(DELETE_LIST[0]);

  const [usersContent, setUsersContent] = useState([]);
  const [userContent, setUserContent] = useState({});

  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({ name: 'Не выбран' });
  const [markets, setMarkets] = useState(MARKETS_FILTER_DEFAULT);
  const [productsSelect, setProductsSelect] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [ozonCategory, setOzonCategory] = useState('');
  const [avitoCategory, setAvitoCategory] = useState('');

  const [productCategory, setProductCategory] = useState(false);

  const [byId, setById] = useState({});
  const [ids, setIds] = useState([]);

  const [count, setCount] = useState(0);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const { role, name } = useSelector((store) => store.user);
  const [contentError, setContentError] = useState('');
  const [ozonError, setOzonError] = useState('');

  const onChange = async (sku, field, value, action) => {
    await ProviderCommonApi.changeProduct({ data: { sku, field, value, action } })
      .then((r) => {
        setById({ ...byId, [r.product.sku]: r.product });
      })
      .catch(console.log);
  };

  const onChangeImages = async ({ data, options }) => {
    await ProviderCommonApi.changeProduct({ data, options })
      .then(r => {
        setById({ ...byId, [r.product.sku]: r.product })

      })
  };

  const onChangeMany = async (skus, field, value) => {
    await ProviderCommonApi.changeProducts({ data: { skus, field, value } }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const params = useMemo(() => {
    return {
      providerId: providerId,
      search: search.trim(),
      market: market === 'Все' || market === null ? undefined : market.toLowerCase(),
      shop: shop === 'Все' ? undefined : shop,
      tab: market === 'Ozon' ? FILTER_OZON[tab] : FILTER[tab],
      limit: parseInt(show),
      contentFilters: {
        category: productCategory,
        contentStatus: status === '' ? (contentError !== '' ? false : undefined) : status,
        contentError: contentError === '' ? undefined : contentError,
        ozonError: ozonError === '' ? undefined : ozonError,
        contentManager: role !== 'content' ? checkContentManager(user) : name,
        isDeleteWb: isDelete.value,
        categoryOzon: ozonCategory,
        categoryAvito: avitoCategory,
      },
    };
  }, [
    search,
    status,
    show,
    shop,
    market,
    shop,
    tab,
    providerId,
    user.name,
    contentError,
    ozonError,
    ozonCategory,
    avitoCategory,
    productCategory,
  ]);

  const loadProducts = () => {
    if (providerId === -1000) {
      return;
    }
    if (market !== null) {
      ProviderCommonApi.getContentCardsBySearch({ data: params }).then((r) => {
        const { hasdata_content, not_loaded, loaded, not_loaded_mp, stopbrand, archive } = r.stock;
        setCount(r.count);
        setCountStock(
          market === 'Ozon'
            ? [hasdata_content, loaded, not_loaded_mp, not_loaded, stopbrand, archive]
            : [hasdata_content, loaded, not_loaded, stopbrand, archive],
        );
        const byIds = {};
        const id = r.products.map((item) => item.sku);
        // eslint-disable-next-line no-return-assign
        r.products.forEach((item) => (byIds[item.sku] = item));

        setById(byIds);
        setIds(id);
      });
    } else {
      showWarningNotify('Не выбрана площадка');
    }
  };

  useEffect(() => {
    loadProducts();
  }, [params]);

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages(images);
  };

  const onChangeTab = (n) => {
    setTab(n);
    setCheckAll(false);
    setProductsSelect({});
  };

  const changeProductSelect = (sku) => {
    if (productsSelect[sku]) {
      const s = productsSelect;
      delete s[sku];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [sku]: true });
    }
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      ids.forEach((item) => {
        map_select[byId[item].sku] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setProductsSelect({});
    }
  };

  const onRemove = async (skus) => {
    const productsKeys = getProviderIdAndArtnumberBySku(skus, byId);

    await ProviderCommonApi.removeProducts({ data: { skus: productsKeys } }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const saveContentManager = async () => {
    await ProviderCommonApi.setContentManager({
      data: {
        skus: Object.keys(productsSelect),
        contentManager: userContent.name,
        market: market.toLowerCase(),
      }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const onMegamarket = async (market, skus, minPurchase) => {
    await ProviderCommonApi.addToMegamarket({
      data: {
        shop: MARKETS_MAP[market],
        skus,
        min_profit: minPurchase,
        fromWarehouse: providerId === -1,
      }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };
  const onYandex = async (market, skus, minPurchase, shelfLife, isKvant) => {
    await ProviderCommonApi.addToYandex({
      data: {
        shop: MARKETS_MAP[market],
        skus,
        min_profit: minPurchase,
        extra: { shelfLife, isKvant },
      }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const onYandexWarehouse = async (skus) => {
    await ProviderCommonApi.addToYandexFromWarehouse({
      data: { skus }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const onWb = async (skus, market, minPurchase, join) => {
    await ProviderCommonApi.addToWb({
      data: {
        shop: MARKETS_MAP[market],
        skus,
        min_profit: minPurchase,
        extra: { join },
        fromWarehouse: providerId === -1,
      }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const onOzon = async (skus, market, minPurchase) => {
    await ProviderCommonApi.addToOzon({
      data: {
        shop: MARKETS_MAP[market],
        skus,
        min_profit: minPurchase,
        fromWarehouse: providerId === -1,
      }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };
  const onOzonWarehouse = async (skus) => {
    await ProviderCommonApi.addToOzonFromWarehouse({
      data: { skus }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const onAvito = async (skus) => {
    await ProviderCommonApi.addToAvito({
      data: {
        shop: 'avito1',
        skus,
        fromWarehouse: providerId === -1,
      }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const onBWhite = async (skus) => {
    await ProviderCommonApi.addToBwhite({
      data: {
        shop: 'bwhite1',
        skus,
        fromWarehouse: providerId === -1,
      }
    }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  // useEffect(() => {
  //   setTab(0);
  // }, [contentMode]);

  useEffect(() => {
    if (contentMode === MODES[2] && (role === 'user' || role === 'content')) {
      setIsDelete({ text: 'Нет', value: false });
    }
  }, [contentMode, role]);

  useEffect(() => {
    setCheckAll(false);
    setOzonError('');
    setProductsSelect({});
  }, [tab, user, status]);

  useEffect(() => {
    UserApi.getUsersByRole({ data: { role: 'content' } })
      .then(r => {
        if (r.users.length > 0) {
          setUsers([{ name: 'Не выбран' }, { name: 'Не назначен' }, ...r.users]);
          setUsersContent(r.users);

          setUser({ name: 'Не выбран' });
        } else {
          setUser({ name: '' });
        }
      })
      .catch();
  }, []);
  ozonError;
  const isAdmin = role === 'owner' || role === 'admin';
  const isContentAdmin = role === 'user';

  useEffect(() => {
    setContentManager(user);
  }, [user]);

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={
              role !== 'content'
                ? market === 'Ozon'
                  ? ['Все товары', 'Залито', 'Не прошло модерацию на Озон', 'Не залито', 'Стоп бренды', 'Архив']
                  : ['Все товары', 'Залито', 'Не залито', 'Стоп бренды', 'Архив']
                : market === 'Ozon'
                  ? [
                    'Все товары',
                    'Залито',
                    'Не прошло модерацию на Озон',
                    'Не залито',
                    'Не прошло модерацию',
                    'С ошибками',
                  ]
                  : ['Все товары', 'Залито', 'Не залито']
            }
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
          {/*         <Row style={{ width: '190px' }}>
            <TextGrey style={{ marginRight: '10px' }}>Режим контента</TextGrey>
            <Switch switched={contentMode} onClick={(v) => changeMode(v)} />
          </Row>*/}

          <div>
            <Select
              select={contentMode}
              list={MODES}
              onSelect={(v) => changeMode(v)}
              //onSelect={(v) => dispatch(uiChangeShipmentMode(v))}
              width="250px"
            />
          </div>
        </Row>

        <Row className={styles.row_input}>
          {Object.keys(productsSelect).length > 0 ? (
            <Row className={styles.row_select}>
              <div className={styles.t_select}>Выбрано товаров: {`${Object.keys(productsSelect).length}`}</div>
              <Button
                type={TYPE_BUTTONS.RED}
                style={{ marginLeft: '15px', marginRight: '15px' }}
                onClick={() => {
                  setCheckAll(false);
                  setProductsSelect({});
                }}
              >
                Очистить выбор
              </Button>

              {role !== 'content' && (
                <>
                  <ProviderProductsContextMenu
                    removeProducts={() => {
                      isAdmin ? onRemove(Object.keys(productsSelect)) : console.log('нет прав');
                    }}
                    archiveProducts={() => onChangeMany(Object.keys(productsSelect), 'is_archive', true)}
                    UnarchiveProducts={() => onChangeMany(Object.keys(productsSelect), 'is_archive', false)}
                    stopbrandProducts={() => onChangeMany(Object.keys(productsSelect), 'is_stop_brand', true)}
                    UnstopbrandProducts={() => onChangeMany(Object.keys(productsSelect), 'is_stop_brand', false)}
                    MarkProducts={() => onChangeMany(Object.keys(productsSelect), 'is_chzn', true)}
                    UnmarkProducts={() => onChangeMany(Object.keys(productsSelect), 'is_chzn', false)}
                    isArchive={FILTER[tab] === 'archive'}
                    isStopbrand={FILTER[tab] === 'stopbrand'}
                    style={{ marginRight: '15px' }}
                  />
                  {contentMode === MODES[0] && (market === 'Wb' || market === 'Ozon' || market === 'Avito') && (
                    <Row style={{ alignItems: 'flex-end', marginRight: '20px' }}>
                      <Select
                        label="Назначить контент менеджера"
                        select={userContent}
                        valueFn={(v) => v.name}
                        list={usersContent}
                        onSelect={(v) => setUserContent(v)}
                        width="250px"
                        style={{ marginLeft: '50px', marginRight: '10px' }}
                      />
                      <Button type={TYPE_BUTTONS.BLUE} onClick={saveContentManager} disabled={!userContent.name}>
                        Подтвердить
                      </Button>
                    </Row>
                  )}
                </>
              )}

              {status && (
                <>
                  {market === 'Megamarket' && (
                    <MegamarketContentButton
                      isAdmin={isAdmin}
                      onClick={(market, minPurchase) =>
                        onMegamarket(market, Object.keys(productsSelect), parseInt(minPurchase))
                      }
                    />
                  )}
                  {market === 'Yandex' && (
                    <YandexContentButton
                      isAdmin={isAdmin}
                      isWarehouse={providerId === -1}
                      onClick={(market, minPurchase, shelfLife, isKvant) =>
                        providerId === -1
                          ? onYandexWarehouse(Object.keys(productsSelect))
                          : onYandex(market, Object.keys(productsSelect), parseInt(minPurchase), shelfLife, isKvant)
                      }
                    />
                  )}
                  {market === 'Wb' && (
                    <WbContentButton
                      roleUser={role}
                      selectMarket={'B-WHITE'}
                      onClick={(minPurchase, market, join) =>
                        onWb(Object.keys(productsSelect), market, parseInt(minPurchase), join)
                      }
                    />
                  )}

                  {market === 'Ozon' && (
                    <>
                      <OzonContentButton
                        roleUser={role}
                        isWarehouse={providerId === -1}
                        selectMarket={'B-WHITE'}
                        onClick={(minPurchase, market, join) =>
                          providerId === -1
                            ? onOzonWarehouse(Object.keys(productsSelect))
                            : onOzon(Object.keys(productsSelect), market, parseInt(minPurchase), join)
                        }
                      />
                    </>
                  )}
                  {market === 'Avito' && (
                    <>
                      <AvitoContentButton
                        roleUser={role}
                        selectMarket={'B-WHITE'}
                        onClick={() => onAvito(Object.keys(productsSelect))}
                      />
                    </>
                  )}
                  {market === 'Bwhite' && (
                    <>
                      <BWhiteContentButton
                        roleUser={role}
                        selectMarket={'B-WHITE'}
                        onClick={() => onBWhite(Object.keys(productsSelect))}
                      />
                    </>
                  )}
                </>
              )}
            </Row>
          ) : (
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          )}
        </Row>

        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['50', '100', '150', '200', '500', '800', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '20px' }}
              />
            </div>
            <Select
              label="Статус карточки"
              select={status}
              valueFn={(v) => STATUSES_MAP[v]}
              list={CARDS_STATUS}
              onSelect={(v) => changeStatus(v)}
              width="220px"
              style={{ marginRight: '20px' }}
            />

            {market === 'Ozon' && tab === 2 ? (
              <Select
                label="Статус ошибки озон"
                select={ozonError}
                valueFn={(v) => OZON_ERROR_VALIDATION[v]}
                list={Object.keys(OZON_ERROR_VALIDATION)}
                onSelect={(v) => setOzonError(v)}
                width="220px"
                style={{ marginRight: '20px' }}
              />
            ) : (
              <Select
                label="Статус ошибки"
                select={contentError}
                valueFn={(v) => FRONT_VALIDATION[v]}
                list={Object.keys(FRONT_VALIDATION)}
                onSelect={(v) => setContentError(v)}
                width="220px"
                style={{ marginRight: '20px' }}
              />
            )}

            {role !== 'content' && (
              <Select
                label="Ответственный контент менеджер"
                select={user}
                valueFn={(v) => v.name}
                list={users}
                onSelect={(v) => setUser(v)}
                width="250px"
                style={{ marginRight: '20px' }}
              />
            )}

            {contentMode === MODES[0] && (
              <ProductCategorySelect
                label="Категория товара"
                searchParams={{
                  contentManager: role !== 'content' ? checkContentManager(user) : name,
                  providerId,
                  market: market?.toLowerCase(),
                }}
                category={productCategory}
                onChange={(v) => setProductCategory(v)}
              />
            )}

            {contentMode === MODES[3] && (
              <OzonCategorySelect
                label="Категория озон"
                searchParams={{
                  ...params,
                  limit: undefined,
                }}
                category={ozonCategory}
                onChange={(v) => setOzonCategory(v)}
                isAllCategotries={false}
              />
            )}

            {contentMode === MODES[4] && (
              <AvitoCategorySelect
                label="Категория авито"
                searchParams={{
                  ...params,
                  limit: undefined,
                }}
                style={{ width: '300px' }}
                category={avitoCategory}
                onChange={(v) => {
                  console.log(v);
                  setAvitoCategory(v);
                }}
                isAllCategotries={false}
              />
            )}
          </Row>

          <div>
            <Row style={{ alignItems: 'flex-end', minHeight: '60px' }}>
              <Row style={{ alignItems: 'flex-start' }}>
                {role !== 'content' && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() =>
                      ProviderCommonApi.excelCheckContent({
                        data: {
                          ...params,
                          limit: undefined,
                          contentManager: undefined,
                          markets,
                        }
                      })
                    }
                    disabled={shop === 'Все' || user.name === 'Не выбран' || user.name === 'Не назначен'}
                    style={{ marginRight: '15px' }}
                  >
                    Скачать данные для проверки
                  </Button>
                )}
                {role !== 'content' && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() =>
                      ProviderCommonApi.excelDefault({
                        data: {
                          ...params,
                          limit: undefined,
                          page: undefined,
                          contentManager: undefined,
                          markets,
                        }
                      })
                    }
                    disabled={count > 20000}
                    style={{ marginRight: '15px' }}
                  >
                    Скачать основные данные
                  </Button>
                )}
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() =>
                    ProviderCommonApi.excelContent({
                      data: {
                        ...params,
                        limit: undefined,
                        contentManager: undefined,
                        markets,
                      }
                    })}
                  disabled={count > 20000}
                  style={{ marginRight: '15px' }}
                >
                  Скачать данные контента (габариты)
                </Button>

                {contentMode === MODES[2] && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() =>
                      ProviderCommonApi.excelWbData({
                        data: {
                          ...params,
                          limit: undefined,
                          page: undefined,
                          contentManager: undefined,
                          markets,
                        }
                      })
                    }
                    disabled={count > 20000}
                    style={{ marginRight: '15px' }}
                  >
                    Скачать вб данные
                  </Button>
                )}
                {contentMode === MODES[3] && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    disabled={ozonCategory.length === 0}
                    onClick={() =>
                      ProviderCommonApi.excelOzonProperties({
                        data: {
                          ...params,
                          limit: undefined,
                          contentManager: undefined,
                          markets,
                        }
                      })
                    }
                    style={{ marginRight: '15px' }}
                  >
                    Скачать озон данные
                  </Button>
                )}
                {contentMode === MODES[4] && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    disabled={avitoCategory.length === 0}
                    onClick={() =>
                      ProviderCommonApi.excelAvitoProperties({
                        data: {
                          ...params,
                          limit: undefined,
                          contentManager: undefined,
                          markets,
                        }
                      })
                    }
                    style={{ marginRight: '15px' }}
                  >
                    Скачать авито данные
                  </Button>
                )}
              </Row>
            </Row>
          </div>
        </Row >
      </WhiteBlock >
      < Table styles={styles.ozon_table} >
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={width[10]}>
            <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
          </HeaderTitle>
          <HeaderTitle width={width[0]} />
          {/* {providerId === 11 && (
            <HeaderTitle width={width[12]} centerText>
              Новое фото
            </HeaderTitle>
          )} */}
          <HeaderTitle width={width[1]} centerText>
            Артикул
          </HeaderTitle>
          <HeaderTitle width={width[1]}>Бренд</HeaderTitle>
          <HeaderTitle width={width[2]}>Название товара</HeaderTitle>
          {contentMode === MODES[0] && role !== 'content' && (
            <>
              <HeaderTitle width={width[3]} centerText>
                Остаток
              </HeaderTitle>
              <HeaderTitle width={width[4]} centerText>
                Цена
              </HeaderTitle>
              <HeaderTitle width={width[4]} centerText style={{ fontSize: '10px' }}>
                Мин. упаковка / шаг
              </HeaderTitle>
              <HeaderTitle width={width[4]} centerText>
                Запрет нектратного набора
              </HeaderTitle>
              <HeaderTitle width={width[7]} centerText>
                Поставщик
              </HeaderTitle>
              <HeaderTitle width={width[13]} centerText>
                Штрихкод товара
              </HeaderTitle>
            </>
          )}

          {contentMode === MODES[1] && (
            <>
              <HeaderTitle width={width[4]} centerText>
                Количество в заказе
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Статус карточки
              </HeaderTitle>
              <HeaderTitle width={width[9]} centerText>
                Габариты, см <br />
                ширина х длина х высота
              </HeaderTitle>
              <HeaderTitle width={width[9]} centerText>
                Проверка объема, литры
              </HeaderTitle>
              <HeaderTitle width={width[4]} centerText>
                Вес, кг
              </HeaderTitle>
              <HeaderTitle width={width[9]} centerText>
                Проверка вес, кг
              </HeaderTitle>
              <HeaderTitle width={width[11]} centerText>
                git Срок годности, месяцы
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Единица измерения
              </HeaderTitle>
            </>
          )}
          {contentMode === MODES[2] && (
            <>
              <HeaderTitle width={width[2]} centerText>
                Наименование WB
              </HeaderTitle>
              <HeaderTitle width={width[14]} centerText>
                Категория WB
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Заголовок для фотошопа
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Единица измерения
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Статус карточки
              </HeaderTitle>
            </>
          )}

          {contentMode === MODES[5] && (
            <>
              <HeaderTitle width={width[2]} centerText>
                Наименование B-White
              </HeaderTitle>
              <HeaderTitle width={width[14]} centerText>
                Категория B-White
              </HeaderTitle>

              <HeaderTitle width={width[12]} centerText>
                Единица измерения
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Статус карточки
              </HeaderTitle>
            </>
          )}

          {contentMode === MODES[3] && (
            <>
              <HeaderTitle width={width[2]} centerText>
                Наименование Озон
              </HeaderTitle>
              <HeaderTitle width={width[14]} centerText>
                Категория Озон
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Заголовок для фотошопа
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Единица измерения
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Статус карточки
              </HeaderTitle>
            </>
          )}
          {contentMode === MODES[4] && (
            <>
              <HeaderTitle width={width[2]} centerText>
                Наименование Авито
              </HeaderTitle>
              <HeaderTitle width={width[2]} centerText>
                Категория Авито
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Заголовок для фотошопа
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Единица измерения
              </HeaderTitle>
              <HeaderTitle width={width[12]} centerText>
                Статус карточки
              </HeaderTitle>
            </>
          )}
          <HeaderTitle width={width[5]} centerText>
            Ответственный контент менеджер
          </HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Дата создания
          </HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Дата обновления
          </HeaderTitle>
          <HeaderTitle width={width[3]} centerText>
            Дней после обновления
          </HeaderTitle>
          {/*          <HeaderTitle  width={width[7]}>
            Мой Склад
          </HeaderTitle>*/}
          {isAdmin && (
            <HeaderTitle width={width[10]} centerText>
              ЧЗ
            </HeaderTitle>
          )}
        </TableHeader>
        {
          ids.map((id) => (
            <ContentWorkLine
              key={id}
              card={byId[id]}
              MODES={MODES}
              providerId={providerId}
              contentMode={contentMode}
              productsSelect={productsSelect}
              onChange={onChange}
              onChangeImages={onChangeImages}
              changeProductSelect={changeProductSelect}
              width={width}
              role={role}
              market={market}
            />
          ))
        }
      </Table >
    </>
  );
}

export default ContentWorkTable;
